<template>
  <div>
    <h2 class="intro-y text-lg font-medium mt-10">Teams</h2>
    <p class="mt-3 text-gray-600">
      Stale teams are older inactive teams with no history in either of the two
      previous event years. They appear separately from other inactive teams.
      Search covers every matching page in the selected tab.
    </p>
    <ListControls
      v-model:status="status"
      v-model:search="search"
      noun="Teams"
      :status-order="['active', 'inactive', 'stale']"
      :counts="counts"
      :total="total"
      :review-window="reviewWindow"
      :loaded="loaded"
      :loading="loading"
      :error="error"
      @retry="refresh"
    >
      <router-link :to="{ name: 'new-team' }" class="btn btn-primary"
        >Add New Team</router-link
      >
    </ListControls>
    <div class="intro-y mt-5" :aria-busy="loading">
      <TeamGrid
        v-if="!loading && !error"
        :grid-data="formattedTeams"
        server-side
        :sort="sort"
        @sort="changeSort"
      />
    </div>
    <div
      v-if="totalPages > 1"
      class="mt-5 flex gap-3 justify-center items-center"
    >
      <button
        type="button"
        class="btn btn-outline-secondary"
        :disabled="page <= 1 || loading"
        @click="changePage(page - 1)"
      >
        Previous
      </button>
      <span>Page {{ page }} of {{ totalPages }}</span>
      <button
        type="button"
        class="btn btn-outline-secondary"
        :disabled="page >= totalPages || loading"
        @click="changePage(page + 1)"
      >
        Next
      </button>
    </div>
  </div>
</template>
<script>
import { computed, defineComponent } from "vue";
import { getTeams } from "@/api/teams.js";
import TeamGrid from "@/components/back-end/TeamGrid";
import ListControls from "@/components/back-end/ListControls.vue";
import { useAdminList } from "@/composables/use-admin-list";

export default defineComponent({
  components: { TeamGrid, ListControls },
  setup() {
    const list = useAdminList(getTeams, "totalRaised:desc");
    const formattedTeams = computed(() =>
      list.data.value.map(team => ({
        id: team.id,
        active: team.active,
        name: team.name,
        city: team.eventCity,
        raised: team.totalRaised,
        participants: (team.members || []).length,
        captain: team.captainPerson
          ? `${team.captainPerson.firstName} ${team.captainPerson.lastName}`
          : "Not Assigned",
        email: team.captainPerson ? team.captainPerson.email : "",
        teamHistory:
          team.teamActivity && team.teamActivity.checked
            ? team.teamActivity.historyYears.join(", ") ||
              `No ${team.teamActivity.reviewYears.join(" or ")} history`
            : "Unknown"
      }))
    );
    return { ...list, formattedTeams };
  }
});
</script>
